<template>
  <div class="full-screen-account-page">
    <Header/>
    <div v-if='render'>
    <user-page v-if="loggedUser && loggedUser.id"  :roles="roles"></user-page>
    </div>
    <company-page v-if="renderCompany" :roles="roles"></company-page>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import Header from '../components/global/Header.vue'
import UserPage from '../components/AccountsPage/UserPage.vue'
import CompanyPage from '../components/AccountsPage/CompanyPage.vue'
import VueJwtDecode from 'vue-jwt-decode'

function decodeJwtToken () {
  let token = localStorage.getItem('token')
  if (token) {
    return VueJwtDecode.decode(token).permissions
  }
  return []
}

export default {
  name: 'AccountsPage',
  components: {
    Header,
    UserPage,
    CompanyPage
  },
  data: () => ({
    render: true,
    renderCompany: false
  }),
  methods: {
  },
  computed: {
    roles: () => decodeJwtToken(),
    ...mapState({
      loggedUser: state => state.auth.userData
    })
  },
  created () {
    if (localStorage.getItem('token') === null) {
      this.render = false
      this.renderCompany = true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/sass/desktop/accountsPage.scss";
  @import "../assets/sass/desktop/notificationPage.scss";
</style>



// WEBPACK FOOTER //
// src/views/AccountsPage.vue